import { elementSizeCssClass, medium } from "../size/index.js";
import defineElement from "../helpers/defineElement.js";
import stacker from "../stacker/stacker.js";

/**
 * Element grouping together and icon and some text.
 * By default, it renders the icon first and the text second.
 *
 * @param {object} [options]
 * @param {Icon} [options.icon] - Icon to render
 * @param {ElementSize} [options.space] - Size of the space between the icon
 *   and the text
 * @param {ElementSize} [options.iconSize] - Size of the icon
 * @param {boolean} [options.reversed] - When true, renders the text first then the
 *   icon
 */
export default defineElement(
	"icon-and-text",
	(
		{ icon, space = medium, iconSize = medium, reversed = false },
		children,
	) => {
		if (!icon) {
			return {
				tag: "span",
				options: { class: "empty" },
				children,
			};
		}

		return {
			tag: "span",
			options: { class: { reversed } },
			children: stacker(
				{ size: space },
				(html) =>
					html.span(
						{
							class: [
								"icon-wrapper",
								elementSizeCssClass("icon-size", iconSize),
							],
						},
						icon,
					),
				...children,
			),
		};
	},
);
